import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface ContratistaPesvPayload {
  nombre: string;
  nit: number;
  tipo_contratista: number;
  servicios: string;
  cantidad_conductores: number;
  cantidad_vehiculos: number;
  tipo_vehiculos: number;
  tipo_vehiculos2: number;
  estado: number;
  fecha_creacion?: string;
  fecha_modificacion?: string;
}

@Injectable({
  providedIn: "root",
})
export class ContratistaPesvService {
  private apiUrl = `${environment.apiUrl}/api/contratista_pesv`;

  constructor(private http: HttpClient) {}

  create(payload: ContratistaPesvPayload): Observable<any> {
    return this.http.post<any>(this.apiUrl, payload, { withCredentials: true });
  }

  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl, { withCredentials: true });
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  update(id: number, payload: Partial<ContratistaPesvPayload>): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }
}
